export default __webpack_public_path__ + "static/10.03-5-eb1b47b7885cf22df098c38cb14eefaa.png";